import React from 'react';

interface Props {
  children: React.ReactNode;
  onClose?: () => void;
}

export function DialogHeader({
  children,
  onClose,
}: Props) {
  return (
    <div className="dialog-header">
      <h2>{children}</h2>

      {onClose && (
        <button
          className="dialog-close"
          onClick={onClose}
        >
          ✕
        </button>
      )}
    </div>
  );
}